/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabriele
 * File: PasswordForgot.tsx
 * Project: mle-client-n
 * Committed last: 2022/5/24 @ 948
 * ---
 * Description:
 */

import { observer }                     from 'mobx-react';
import { Card, Intent, NonIdealState }  from '@blueprintjs/core';
import React, { useCallback, useState } from 'react';
import {
  ResetMailForm,
  ResetMailFormData
}                                       from '../components/forms/ResetMailForm';
import { mleAuthProviderRestClient }    from '../api/ap';
import { MleAuthProviderEndpoints }     from '../api/ap/endpoints';
import { MleToaster }                   from '../common/toast';

export const PasswordForgot = observer((props: any) => {
  const [mailSent, setMailSent] = useState(false);

  const handleFormSubmit = useCallback((values: ResetMailFormData) => {
    (async () => {
      try {
        const result = await mleAuthProviderRestClient.post(
          MleAuthProviderEndpoints.RESET_PWD_TOKEN,
          {
            recipientAddress: values.email
          } as any);

        setMailSent(true);
      } catch (e) {
        MleToaster.getInstance().show({
          message: 'Nessun account con la mail inserita',
          intent: Intent.DANGER
        });
      }
    })();
  }, [setMailSent]);

  return (
    <div className="mle-center-both-axes-parent">
      <div className="mle-center-both-axes-child w-96">
        <Card className="font-semibold w-96">
          { !mailSent ?
            <div><h4 className="bp4-heading">Inserisci la tua mail, riceverai un
              link
              per resettare la password</h4>
              <a href="/auth/login" className="my-4">Torna al login</a>
              <ResetMailForm onSubmit={ handleFormSubmit }/></div> :
            <div>
              <NonIdealState icon="tick" title="Email inviata"
                             description={ <div
                               className="text-bpgray-200 text-xs">Email di
                               reset della password inviata correttamente.
                               Controlla la tua casella di posta</div> }/>
            </div> }
        </Card>
      </div>
    </div>
  );
});